'use client';

import { useState, useEffect, useCallback } from 'react';

type Testimonial = {
  quote: string;
  name: string;
  company: string;
  emoji: string;
};

const allTestimonials: Testimonial[] = [
  {
    quote:
      "Cindy s'approprie votre marque et lui apporte une vraie dimension engageante. C'est exactement ce dont on avait besoin.",
    name: 'Emmanuelle P.',
    company: 'Social Media Lab',
    emoji: '📊',
  },
  {
    quote:
      'Libérée de la charge mentale des réseaux. Les résultats ont été visibles dès le premier mois.',
    name: 'Gwenaëlle',
    company: 'Lithothérapie',
    emoji: '✨',
  },
  {
    quote:
      'Des posts géniaux, bien écrits, très divers. Les gens adorent et la communauté progresse régulièrement.',
    name: 'Alison R.',
    company: 'DogShop',
    emoji: '🐾',
  },
  {
    quote:
      'Une perle rare : elle écoute vraiment vos besoins, arrangeante, disponible et surtout elle obtient des résultats.',
    name: 'Christian',
    company: 'Chirurgien-dentiste',
    emoji: '🏥',
  },
  {
    quote:
      "Elle a parfaitement compris l'essence de ma marque et la retranscrit en publications qui nous ressemblent.",
    name: 'Elodie F.',
    company: 'Wonder Notion',
    emoji: '🌸',
  },
  {
    quote:
      'Un vrai partenaire de confiance : réactive, adaptable, de bons conseils. Je ne gère plus mes réseaux seule.',
    name: 'Amandine',
    company: 'BeTrue',
    emoji: '💪',
  },
];

const PER_PAGE = 3;
const TOTAL_PAGES = Math.ceil(allTestimonials.length / PER_PAGE);
const AUTO_DELAY = 6000;

export default function TestimonialsGR() {
  const [page, setPage] = useState(0);
  const [visible, setVisible] = useState(true);

  const goTo = useCallback((next: number) => {
    setVisible(false);
    setTimeout(() => {
      setPage(next);
      setVisible(true);
    }, 280);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((page + 1) % TOTAL_PAGES);
    }, AUTO_DELAY);
    return () => clearInterval(timer);
  }, [page, goTo]);

  const cards = allTestimonials.slice(page * PER_PAGE, page * PER_PAGE + PER_PAGE);

  return (
    <>
      <div
        className="gr-testi-grid"
        style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.28s ease' }}
      >
        {cards.map((t, i) => (
          <div key={`${page}-${i}`} className="gr-testi-card">
            <div className="gr-testi-stars">★★★★★</div>
            <p className="gr-testi-quote">&ldquo;{t.quote}&rdquo;</p>
            <div className="gr-testi-footer">
              <div className="gr-testi-avatar-ring">
                <div className="gr-testi-avatar-inner">{t.emoji}</div>
              </div>
              <div>
                <div className="gr-testi-name">{t.name}</div>
                <div className="gr-testi-company">{t.company}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '28px' }}>
        {Array.from({ length: TOTAL_PAGES }).map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            aria-label={`Page ${i + 1}`}
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              background: i === page ? '#be185d' : 'rgba(26,10,30,0.15)',
              transition: 'background 0.3s',
            }}
          />
        ))}
      </div>
    </>
  );
}
